import { lazy, Suspense } from "react";
import { Link } from "react-router-dom";

import FeatureNewHead from "./FeatureNewHead";
import LyftTeamlogo from "../cloneApps/LyftClone/LyftTeamlogo";

const FeatureNewContent = lazy(() => import("./FeatureNewContent"));
const ShuttleAppreciation = lazy(() => import("../shuttle_software/ShuttleAppreciation"));
const FeatureNewFacts = lazy(() => import("./FeatureNewFacts"));
const BlogDetailCards = lazy(() => import("../BlogDetails/BlogDetailCards"));
const FeatureNewLevel = lazy(() => import("./FeatureNewLevel"));


export default function FeatureNew() {
  return (
    <>
      <FeatureNewHead />
      <LyftTeamlogo heading={true} newClass="featue-new-team" />

      <Suspense fallback={null}>
        <FeatureNewContent />
        <div className="feature-new-appreciation">
          <ShuttleAppreciation />
        </div>
        <FeatureNewFacts />
        <div className="feature-new-blogs">
          <BlogDetailCards TopHeading="Our Blogs" />
          <div className="text-center">
            <Link to={"/blog"} className="default-btn">VIEW MORE</Link>
          </div>
        </div>
        <FeatureNewLevel />
      </Suspense>
    </>
  )
}
